import { useEffect, useMemo, useState } from 'react';
import { parseShare } from '../utils/share';

/**
 * Leest bij het opstarten de `?share=`-parameter en ruimt de URL op (zonder herladen).
 * De validatie mag later beschikbaar komen (bv. pas als de museumlijst geladen is): tot dan is er
 * nog geen `pending` en ook geen `invalid`. `pending` bevat de gevalideerde gegevens tot de gebruiker kiest.
 */
export function useShareLink<T>(validate: ((raw: unknown) => T | undefined) | null) {
  const [param] = useState(() => new URLSearchParams(window.location.search).get('share'));
  const [afgehandeld, setAfgehandeld] = useState(false);

  useEffect(() => {
    if (param !== null) window.history.replaceState({}, document.title, window.location.pathname);
  }, [param]);

  const payload = useMemo(() => (param !== null && validate ? parseShare(param, validate) : undefined), [param, validate]);

  return {
    pending: !afgehandeld && payload !== undefined ? payload : null,
    /** true als er een link was, maar die ongeldig of beschadigd bleek */
    invalid: param !== null && validate !== null && payload === undefined,
    dismiss: () => setAfgehandeld(true),
  };
}
